import type { Locale } from "./en";

// Ukrainian translations. Missing keys fall back to English via i18next.
export const uk: Locale = {
  common: {
    home: "Головна",
    no_scores: "Ще немає балів",
    points_count_one: "{{count}} бал",
    points_count_other: "{{count}} балів",
    questions_count_one: "{{count}} запитання",
    questions_count_other: "{{count}} запитань",
  },
  home: {
    placeholder: "Код гри",
    enter: "Увійти",
    error_invalid_code: "Введи 6-значний код гри від учителя.",
    footer: "Запусти Binogi Buzz із продуктів Binogi.com.",
    language_label: "Мова",
  },
  errors: {
    generic: "Щось пішло не так. Спробуйте ще раз.",
    stale_client: "Сторінка застаріла — оновіть її.",
    session_not_found: "Сесію не знайдено.",
    session_not_open: "Цю сесію завершено.",
    session_not_active: "Це запитання або сесія вже завершилися.",
    not_teacher: "Це може зробити лише вчитель.",
    already_answered: "Ви вже відповіли на це запитання.",
    wrong_question_index: "Це запитання ще не почалося.",
    name_taken: "Це ім’я вже зайняте. Спробуйте інше.",
    character_busy: "Зараз не вдалося дати вам персонажа — спробуйте ще раз.",
  },
  host: {
    input: {
      heading: "Запустіть Buzz",
      lead:
        "Введіть код уроку Binogi, який вивчають ваші учні. Ми завантажимо запитання з нього та створимо сесію, яку можна показати на дошці.",
      lesson_code_label: "Код уроку",
      placeholder_code: "BIH750",
      load_button: "Завантажити урок",
      try_hint: "Спробуйте:",
      error_invalid_code: "Введіть код уроку Binogi, наприклад BIH750.",
      error_not_found: "Урок із кодом {{code}} не знайдено.",
      error_unreachable: "Не вдалося зв’язатися із сервером уроків. Перевірте з’єднання та спробуйте ще раз.",
      error_no_questions: "В уроці {{code}} немає запитань, які може використати Buzz.",
      error_no_level_questions: "В уроці {{code}} немає запитань вибраного рівня.",
    },
    loading: "Завантаження уроку…",
    placeholder_title: "Запустіть Binogi Buzz",
    tab_details: "Деталі",
    tab_questions: "Запитання",
    settings: "Налаштування",
    number_of_students: "Кількість учнів",
    fewer_students: "Менше учнів",
    more_students: "Більше учнів",
    player_names: "Імена гравців",
    player_anonymous: "Анонімно",
    player_self_chosen: "Учні обирають",
    language: "Мова",
    language_teacher: "Обирає вчитель",
    language_students: "Обирають учні",
    time_per_question: "Час на запитання",
    time_option: "{{seconds}} с",
    start_button: "Розпочати сесію",
    start_disabled: "Вкажіть кількість учнів, щоб почати",
    creating: "Створення сесії…",
    error_no_questions: "Залиште щонайменше одне запитання, перш ніж починати.",
    error_create_failed: "Не вдалося створити сесію",
    error_load_failed: "Не вдалося завантажити урок",
    no_session: "Немає активної сесії.",
    back_to_review: "Назад до запитань",
    errors: {
      dismiss: "Закрити",
      refresh: "Оновити",
      attach_failed: "Цей екран не зміг підключитися як вчитель.",
      unreachable: "Не вдалося зв’язатися із сервером. Оновіть сторінку, щоб спробувати ще раз.",
      no_token: "Ця вкладка більше не може керувати вікториною. Відкрийте Buzz зі свого уроку, щоб почати нову сесію.",
      taken_over: "Тепер цією вікториною керують з іншого екрана.",
      stale_question: "Buzz оновився під час вікторини, тому цей екран не може її продовжити. Перезавантажте сторінку, щоб продовжити вікторину з того місця, де зараз клас.",
      question_moved_on: "Вікторина вже пішла далі, тому цей екран відстав. Перезавантажте сторінку, щоб продовжити вікторину з того місця, де зараз клас.",
    },
    entry: {
      opening: "Відкриваємо екран учителя…",
      token_title: "Це посилання для вчителя не можна відкрити",
      token_body: "У посиланні немає ключа вчителя, або термін його дії минув. Відкрийте Buzz зі свого уроку, щоб створити нову сесію.",
      not_found_title: "Сесію не знайдено",
      not_found_body: "Цієї сесії вікторини більше не існує. Створіть нову, щоб продовжити.",
      back: "На головну",
    },
    questions: {
      drag_aria: "Перетягнути, щоб змінити порядок",
      remove_aria: "Видалити запитання",
      empty: "У цій сесії не залишилося запитань.",
      add: "Додати",
      add_aria: "Додати запитання: {{text}}",
      add_all: "Додати всі",
      add_all_n: "Додати всі {{count}} запитань",
      more_one: "Ще {{count}} запитання в цьому уроці",
      more_few: "Ще {{count}} запитання в цьому уроці",
      more_many: "Ще {{count}} запитань у цьому уроці",
      more_other: "Ще {{count}} запитань у цьому уроці",
      level_easy: "Легкий",
      level_medium: "Середній",
      level_hard: "Складний",
      multi: "Кілька",
    },
    lobby: {
      go_to: "Перейдіть на <strong>buzz.binogi.com</strong> та введіть:",
      or_qr: "…або відскануй QR-код",
      students_joined_of: "Доєдналося {{joined}} із {{expected}} учнів",
      students_joined_one: "{{count}} учень доєднався",
      students_joined_other: "{{count}} учнів доєдналися",
      waiting: "Чекаємо, поки учні приєднаються…",
      start_game: "Почати гру",
      connected: "Підключено",
      connecting: "Підключення…",
      copy_link: "Скопіювати посилання",
      copy_link_copied: "Скопійовано!",
    },
    question: {
      header: "Запитання {{index}} з {{total}}",
      level: "Рівень {{level}}",
      none: "Немає активного запитання.",
      answered: "Відповіли",
      top_n: "Топ {{count}}",
      answers_heading: "Відповіді",
      end_question: "Завершити запитання",
      next_question: "Наступне запитання",
      see_results: "Переглянути підсумки",
    },
    results: {
      heading: "Підсумкові результати",
      all_players: "Усі гравці",
      end_session: "Завершити сесію",
      new_session: "Нова сесія",
      none: "У цій сесії немає гравців.",
    },
  },
  join: {
    code_label: "Код гри",
    name_label: "Твоє ім'я",
    name_placeholder: "Введи своє ім'я",
    join_button: "Приєднатися",
    joining: "Приєднання…",
    checking: "Перевіряємо…",
    character_hint: "Коли приєднаєшся, отримаєш веселе ім'я персонажа Binogi.",
    error_not_found:
      "Цей код поки не належить до активної сесії. Перевір його з учителем.",
    error_lookup_failed: "Не вдалося знайти сесію",
    error_code_required: "Введи 6-значний код.",
    error_name_required: "Введи своє ім'я.",
  },
  play: {
    superseded: "Ви підключені в іншій вкладці — закрийте її, щоб продовжити гру тут.",
    back_to_join: "Повернутися до входу",
    no_round: "Немає даних раунду.",
    not_joined: "Ви не приєдналися до жодної сесії.",
    no_question: "Немає активного запитання.",
    keep_awake_hint: "Торкніться екрана, щоб він не згасав",
    waiting: {
      you_are: "Ти —",
      get_ready_named: "Приготуйся, {{name}}!",
      get_ready: "Приготуйся до вікторини!",
      in_room_label: "Учнів у класі",
      in_room_one: "{{count}} учень у класі",
      in_room_other: "{{count}} учнів у класі",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "Відповідь надіслано!",
      times_up: "Час вийшов",
      submit: "Надіслати",
      submit_n: "Надіслати {{count}} відповіді",
    },
    between: {
      correct: "Правильно!",
      wrong: "Майже!",
      times_up: "Час вийшов",
      points_gained: "+{{count}} балів",
      your_score: "Твій рахунок",
      your_rank: "Місце {{rank}}",
      top_n: "Топ {{count}}",
      waiting_next: "Чекаємо на наступне запитання…",
    },
    finished: {
      heading: "Дякуємо, що грав у Binogi Buzz!",
      your_final_rank: "Твоє підсумкове місце",
      top_n: "Топ {{count}}",
      none: "Немає результатів для показу.",
    },
  },
  characters: {
    heading: "Персонажі Binogi",
    lead: "{{count}} учнів отримають персонажа, коли приєднаються — у такому порядку.",
  },
};
